export const OPTION_VARIANTS = {  
    Toggle: "Toggle",
    Checkbox: "Checkbox",
};
